var _toConsumableArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _slicedToArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectWithoutProperties");

var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _require = require('zlib'),
    inflateRawSync = _require.inflateRawSync;

var base64url = require('../help/base64url');

var getKey = require('../help/get_key');

var _require2 = require('../jwks'),
    KeyStore = _require2.KeyStore;

var errors = require('../errors');

var _require3 = require('../jwa'),
    check = _require3.check,
    decrypt = _require3.decrypt,
    keyManagementDecrypt = _require3.keyManagementDecrypt;

var JWK = require('../jwk');

var _require4 = require('../help/key_object'),
    createSecretKey = _require4.createSecretKey;

var generateCEK = require('./generate_cek');

var validateHeaders = require('./validate_headers');

var _require5 = require('./serializers'),
    resolveSerialization = _require5.detect;

var SINGLE_RECIPIENT = new Set(['compact', 'flattened']);

var combineHeader = function combineHeader() {
  var prot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var unprotected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var header = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof prot === 'string') {
    prot = base64url.JSON.decode(prot);
  }

  var p2s = prot.p2s || unprotected.p2s || header.p2s;
  var apu = prot.apu || unprotected.apu || header.apu;
  var apv = prot.apv || unprotected.apv || header.apv;
  var iv = prot.iv || unprotected.iv || header.iv;
  var tag = prot.tag || unprotected.tag || header.tag;
  return _objectSpread({}, prot, {}, unprotected, {}, header, {}, typeof p2s === 'string' ? {
    p2s: base64url.decodeToBuffer(p2s)
  } : undefined, {}, typeof apu === 'string' ? {
    apu: base64url.decodeToBuffer(apu)
  } : undefined, {}, typeof apv === 'string' ? {
    apv: base64url.decodeToBuffer(apv)
  } : undefined, {}, typeof iv === 'string' ? {
    iv: base64url.decodeToBuffer(iv)
  } : undefined, {}, typeof tag === 'string' ? {
    tag: base64url.decodeToBuffer(tag)
  } : undefined);
};

var validateAlgorithms = function validateAlgorithms(algorithms, option) {
  if (algorithms !== undefined && (!Array.isArray(algorithms) || algorithms.some(function (s) {
    return typeof s !== 'string' || !s;
  }))) {
    throw new TypeError("\"".concat(option, "\" option must be an array of non-empty strings"));
  }

  if (!algorithms) {
    return undefined;
  }

  return new Set(algorithms);
};
/*
 * @public
 */


var jweDecrypt = function jweDecrypt(skipValidateHeaders, serialization, jwe, key) {
  var _ref = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
      _ref$crit = _ref.crit,
      crit = _ref$crit === void 0 ? [] : _ref$crit,
      _ref$complete = _ref.complete,
      complete = _ref$complete === void 0 ? false : _ref$complete,
      keyManagementAlgorithms = _ref.keyManagementAlgorithms,
      contentEncryptionAlgorithms = _ref.contentEncryptionAlgorithms;

  key = getKey(key, true);
  keyManagementAlgorithms = validateAlgorithms(keyManagementAlgorithms, 'keyManagementAlgorithms');
  contentEncryptionAlgorithms = validateAlgorithms(contentEncryptionAlgorithms, 'contentEncryptionAlgorithms');

  if (!Array.isArray(crit) || crit.some(function (s) {
    return typeof s !== 'string' || !s;
  })) {
    throw new TypeError('"crit" option must be an array of non-empty strings');
  }

  if (!serialization) {
    serialization = resolveSerialization(jwe);
  }

  var alg, ciphertext, enc, encryptedKey, iv, opts, prot, tag, unprotected, cek, aad, header; // treat general format with one recipient as flattened
  // skips iteration and avoids multi errors in this case

  if (serialization === 'general' && jwe.recipients.length === 1) {
    serialization = 'flattened';

    var _jwe = jwe,
        _recipients = _jwe.recipients,
        _root = _objectWithoutProperties(_jwe, ["recipients"]);

    jwe = _objectSpread({}, _root, {}, _recipients[0]);
  }

  if (SINGLE_RECIPIENT.has(serialization)) {
    if (serialization === 'compact') {
      // compact serialization format
      var _jwe$split = jwe.split('.');

      var _jwe$split2 = _slicedToArray(_jwe$split, 5);

      prot = _jwe$split2[0];
      encryptedKey = _jwe$split2[1];
      iv = _jwe$split2[2];
      ciphertext = _jwe$split2[3];
      tag = _jwe$split2[4];
    } else {
      // flattened serialization format
      var _jwe2 = jwe;
      prot = _jwe2.protected;
      encryptedKey = _jwe2.encrypted_key;
      iv = _jwe2.iv;
      ciphertext = _jwe2.ciphertext;
      tag = _jwe2.tag;
      unprotected = _jwe2.unprotected;
      aad = _jwe2.aad;
      header = _jwe2.header;
    }

    if (!skipValidateHeaders) {
      validateHeaders(prot, unprotected, [{
        header: header
      }], true, crit);
    }

    opts = combineHeader(prot, unprotected, header);
    var _opts = opts;
    alg = _opts.alg;
    enc = _opts.enc;

    if (keyManagementAlgorithms && !keyManagementAlgorithms.has(alg)) {
      throw new errors.JOSEAlgNotWhitelisted('key management algorithm not whitelisted');
    }

    if (contentEncryptionAlgorithms && !contentEncryptionAlgorithms.has(enc)) {
      throw new errors.JOSEAlgNotWhitelisted('content encryption algorithm not whitelisted');
    }

    if (key instanceof KeyStore) {
      var keystore = key;
      var keys;

      if (opts.alg === 'dir') {
        keys = keystore.all({
          kid: opts.kid,
          alg: opts.enc,
          key_ops: ['decrypt']
        });
      } else {
        keys = keystore.all({
          kid: opts.kid,
          alg: opts.alg,
          key_ops: ['unwrapKey']
        });
      }

      switch (keys.length) {
        case 0:
          throw new errors.JWKSNoMatchingKey();

        case 1:
          // treat the call as if a Key instance was passed in
          // skips iteration and avoids multi errors in this case
          key = keys[0];
          break;

        default:
          {
            var _errs = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _key = _step.value;

                try {
                  return jweDecrypt(true, serialization, jwe, _key, {
                    crit: crit,
                    complete: complete,
                    contentEncryptionAlgorithms: contentEncryptionAlgorithms ? _toConsumableArray(contentEncryptionAlgorithms) : undefined,
                    keyManagementAlgorithms: keyManagementAlgorithms ? _toConsumableArray(keyManagementAlgorithms) : undefined
                  });
                } catch (err) {
                  _errs.push(err);

                  continue;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            var _multi = new errors.JOSEMultiError(_errs);

            if (_toConsumableArray(_multi).some(function (e) {
              return e instanceof errors.JWEDecryptionFailed;
            })) {
              throw new errors.JWEDecryptionFailed();
            }

            throw _multi;
          }
      }
    }

    check.apply(void 0, [key].concat(_toConsumableArray(alg === 'dir' ? ['decrypt', enc] : ['keyManagementDecrypt', alg])));

    try {
      if (alg === 'dir') {
        cek = JWK.asKey(key, {
          alg: enc,
          use: 'enc'
        });
      } else if (alg === 'ECDH-ES') {
        var unwrapped = keyManagementDecrypt(alg, key, undefined, opts);
        cek = JWK.asKey(createSecretKey(unwrapped), {
          alg: enc,
          use: 'enc'
        });
      } else {
        var _unwrapped = keyManagementDecrypt(alg, key, base64url.decodeToBuffer(encryptedKey), opts);

        cek = JWK.asKey(createSecretKey(_unwrapped), {
          alg: enc,
          use: 'enc'
        });
      }
    } catch (err) {
      // To mitigate the attacks described in RFC 3218, the
      // recipient MUST NOT distinguish between format, padding, and length
      // errors of encrypted keys.  It is strongly recommended, in the event
      // of receiving an improperly formatted key, that the recipient
      // substitute a randomly generated CEK and proceed to the next step, to
      // mitigate timing attacks.
      cek = generateCEK(enc);
    }

    var adata;

    if (aad) {
      adata = Buffer.concat([Buffer.from(prot || ''), Buffer.from('.'), Buffer.from(aad)]);
    } else {
      adata = Buffer.from(prot || '');
    }

    try {
      iv = base64url.decodeToBuffer(iv);
    } catch (err) {}

    try {
      tag = base64url.decodeToBuffer(tag);
    } catch (err) {}

    var cleartext = decrypt(enc, cek, base64url.decodeToBuffer(ciphertext), {
      iv: iv,
      tag: tag,
      aad: adata
    });

    if (opts.zip) {
      cleartext = inflateRawSync(cleartext);
    }

    if (complete) {
      var result = {
        cleartext: cleartext,
        key: key,
        cek: cek
      };
      if (aad) result.aad = aad;
      if (header) result.header = header;
      if (unprotected) result.unprotected = unprotected;
      if (prot) result.protected = base64url.JSON.decode(prot);
      return result;
    }

    return cleartext;
  }

  validateHeaders(jwe.protected, jwe.unprotected, jwe.recipients.map(function (_ref2) {
    var header = _ref2.header;
    return {
      header: header
    };
  }), true, crit); // general serialization format

  var _jwe3 = jwe,
      recipients = _jwe3.recipients,
      root = _objectWithoutProperties(_jwe3, ["recipients"]);

  var errs = [];
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = recipients[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var recipient = _step2.value;

      try {
        return jweDecrypt(true, 'flattened', _objectSpread({}, root, {}, recipient), key, {
          crit: crit,
          complete: complete,
          contentEncryptionAlgorithms: contentEncryptionAlgorithms ? _toConsumableArray(contentEncryptionAlgorithms) : undefined,
          keyManagementAlgorithms: keyManagementAlgorithms ? _toConsumableArray(keyManagementAlgorithms) : undefined
        });
      } catch (err) {
        errs.push(err);
        continue;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  var multi = new errors.JOSEMultiError(errs);

  if (_toConsumableArray(multi).some(function (e) {
    return e instanceof errors.JWEDecryptionFailed;
  })) {
    throw new errors.JWEDecryptionFailed();
  } else if (_toConsumableArray(multi).every(function (e) {
    return e instanceof errors.JWKSNoMatchingKey;
  })) {
    throw new errors.JWKSNoMatchingKey();
  }

  throw multi;
};

module.exports = jweDecrypt.bind(undefined, false, undefined);